import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loadingScreenService: LoadingScreenService) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loadingScreenService.loadingToggleStatus(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loadingScreenService.loadingToggleStatus(true);

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.removeRequest(req);
        }
      }),
      catchError((err: any) => {
        // แค่ลบ request ออกจากรายการและส่ง error ต่อไป
        // ไม่ต้องจัดการ error เอง
        this.removeRequest(req);
        return throwError(() => err);
      }),
      finalize(() => {
        // ตรวจสอบซ้ำเพื่อให้แน่ใจว่า request ถูกลบออกแล้ว
        this.removeRequest(req);
      })
    );
  }
}
